<div class="dialog-banner">
  <div class="banner-left">
    <div class="banner-title">Créer une facture (hors FSE)</div>
    <!-- <div class="banner-meta">
      <span><strong>Profil émetteur :</strong>
        <ng-container *ngIf="form.get('idProfil')?.value as pid">
          {{ (data?.profils || []) | json }}
        </ng-container>
      </span>
    </div> -->
  </div>

  <div class="banner-right">
    <div class="banner-actions">
      <button mat-icon-button mat-dialog-close class="banner-close" aria-label="Fermer">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>

<mat-dialog-content class="form-content">

  <!-- Patient -->
  <div class="section">
    <mat-form-field appearance="outline" class="search-bar" [formGroup]="form">
      <mat-label>Rechercher un patient existant ou saisir les informations patient...</mat-label>
      <input #searchInput matInput formControlName="searchPatient" [matAutocomplete]="auto" [readonly]="patientId">
      <mat-error *ngIf="form.get('idPatient')?.invalid">Patient requis</mat-error>
    </mat-form-field>

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayPatient"
                      (optionSelected)="onPatientSelected($event.option.value)">
      <mat-option *ngFor="let p of patientsList" [value]="p">
        <div class="patient-option">
          <!-- <div class="title" *ngIf="patientVu">{{p}}</div> -->
          <div class="title" >{{ p.nomUsage }}, {{ p.nomPrenomDateNaissance }}</div>
          <div class="meta" *ngIf="p.numSecSociale">{{ p.numSecSociale }}</div>
        </div>
      </mat-option>
      <mat-option *ngIf="!loading && (patientsList?.length || 0) === 0 && form.get('searchPatient')?.value">
        Aucun résultat
      </mat-option>
    </mat-autocomplete>
    <!-- Affichage du choix -->
    <div *ngIf="patientId" class="mt-2">
      Patient : {{ SearchPatientNom}}
      <button mat-icon-button matSuffix aria-label="Chercher un nouveau patient" *ngIf="patientId" (click)="breakLinkPatient()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <form *ngIf="form" [formGroup]="form">
    <div class="section">
      <!-- Profil -->
      <mat-form-field appearance="outline" class="profil-field">
        <mat-label>Utlisateur</mat-label>
        <mat-select formControlName="idProfil" required>
          <mat-option *ngFor="let pr of ListProfils || []" [value]="pr.id">
            {{ pr.nom }} {{ pr.prenom }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('idProfil')?.invalid">Profil requis</mat-error>
      </mat-form-field>

      <!-- Références libres
      <mat-form-field appearance="outline" class="numFactLibre-field">
        <mat-label>N° facture libre (recommandé)</mat-label>
        <input matInput formControlName="numFactureLibre" />
      </mat-form-field> -->

    </div>

    <div class="section">
      <!-- Date facture -->
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>Date facture</mat-label>
        <input matInput [matDatepicker]="df" formControlName="dateFacture" [max]="today" required />
        <mat-datepicker-toggle matSuffix [for]="df"></mat-datepicker-toggle>
        <mat-datepicker #df></mat-datepicker>
        <mat-error *ngIf="form.get('dateFacture')?.invalid">Date requise</mat-error>
      </mat-form-field>

      <!-- Date soins (optionnelle) -->
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>Date soins</mat-label>
        <input matInput [matDatepicker]="ds" formControlName="dateSoins" [max]="form.get('dateFacture')?.value"/>
        <mat-datepicker-toggle matSuffix [for]="ds"></mat-datepicker-toggle>
        <mat-datepicker #ds></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="section">
      <!-- Type FSE -->
      <mat-form-field appearance="outline" class="type-facture">
        <mat-label>Type</mat-label>
        <mat-select formControlName="typeFse" required>
          <mat-option *ngFor="let t of typesFse" [value]="t.value">{{ t.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Libellé -->
      <mat-form-field appearance="outline" class="libelle-facture" required>
        <mat-label>Libellé</mat-label>
        <input matInput formControlName="libelleFacture" placeholder="Ex. VG + MD / motif libre" />
      </mat-form-field>
    </div>

    <div class="section">
      <!-- Répartition (optionnelle) -->
      <mat-form-field appearance="outline" class="repartition-facture">
        <mat-label>AMO</mat-label>
        <input matInput type="number" formControlName="montantAMO" min="0" step="1" inputmode="decimal" />
        <mat-icon matSuffix>euro</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="repartition-facture">
        <mat-label>AMC</mat-label>
        <input matInput type="number" formControlName="montantAMC" min="0" step="1" inputmode="decimal" />
        <mat-icon matSuffix>euro</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="repartition-facture">
        <mat-label>Patient</mat-label>
        <input matInput type="number" formControlName="montantPatient" min="0" step="1" inputmode="decimal" />
        <mat-icon matSuffix>euro</mat-icon>
      </mat-form-field>
    </div>
    <div class="section-total">
      <!-- Montant total -->
      <!-- <div class="total" >Total facture : {{ form.get('montantTotal').value  | number:'1.2-2' }} €</div> -->
      <!-- <mat-form-field appearance="outline" class="repartition-facture">
        <mat-label>Total</mat-label>
        <input matInput type="number" formControlName="montantTotal" readonly tabindex="-1" />
        <mat-icon matSuffix>euro</mat-icon>
      </mat-form-field> -->
      <div class="repartition-facture display-only">
        <div class="label">Total</div>
        <div class="value">{{ form.get('montantTotal')?.value | number:'1.2-2' }} €</div>
      </div>
    </div>




    <!-- <mat-form-field appearance="outline">
      <mat-label>Identifiant FSE (si connu)</mat-label>
      <input matInput formControlName="identifiantFactureFSE" />
    </mat-form-field> -->
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Annuler</button>
  <button mat-raised-button color="primary" (click)="onCreate()" [disabled]="form.invalid">
    Créer
  </button>
</mat-dialog-actions>
